import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import * as React from 'react';

import { getContentfulImage } from '../../utils/getContentfulImage';
import { ICustomGatsbyImageData } from '../../utils/types';

type GatsbyImageProps = React.ComponentProps<typeof GatsbyImage>;

export interface IContentfulImageProps
  extends Omit<GatsbyImageProps, 'image' | 'alt'> {
  image: ICustomGatsbyImageData | IGatsbyImageData | null | undefined;
  alt?: string;
}

function isContentfulImage(
  image: IContentfulImageProps['image']
): image is ICustomGatsbyImageData {
  return Boolean(image && 'gatsbyImageData' in image);
}

export const ContentfulImage: React.FunctionComponent<IContentfulImageProps> = ({
  image,
  alt = '',
  ...props
}) => {
  const resolved = isContentfulImage(image)
    ? getContentfulImage(image)
    : image;

  if (!resolved) {
    return null;
  }

  const imageAlt = isContentfulImage(image) ? image.title || alt : alt;

  return <GatsbyImage image={resolved} alt={imageAlt} {...props} />;
};
